<template>
    <div class="phoneMacSet" v-if="permisShow('移动端-机器认证查看')">
        <div class="key_top">
            <ul class="key_list">
                <li class="conditions_list_item">
                    <span>IMEI地址：</span>
                    <el-input v-model="search.macAddress" @input="currentPage=1,pageNumber=1,macQuery()"
                        placeholder="请输入IMEI地址" clearable></el-input>
                </li>
                <li class="conditions_list_item">
                    <span>员工：</span>
                    <el-input v-model="search.phoneEmployeeName" @input="currentPage=1,pageNumber=1,macQuery()"
                        placeholder="请输入员工" clearable></el-input>
                </li>
                <li class="conditions_list_item">
                    <span>申请时间：</span>
                    <el-date-picker v-model="search.date" @change="currentPage=1,pageNumber=1,macQuery()"
                        value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期"
                        end-placeholder="结束日期"></el-date-picker>
                </li>
                <li class="conditions_list_item">
                    <span>状态：</span>
                    <el-select v-model="search.status" placeholder="不限" clearable  @change="currentPage=1,pageNumber=1,macQuery()">
                        <el-option v-for="(item,index) in this.statusList" :key="index" :label="item.name"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <!-- <el-input v-model="search.status" @input="currentPage=1,pageNumber=1,macQuery()" placeholder="请输入备注"
                        clearable></el-input> -->
                </li>
                <li class="conditions_list_item time">
                    <span>最后登录时间：</span>
                    <el-date-picker v-model="search.loginDate" @change="currentPage=1,pageNumber=1,macQuery()"
                        value-format="yyyy-MM-dd" type="daterange" range-separator="-" start-placeholder="开始日期"
                        end-placeholder="结束日期"></el-date-picker>
                </li>
            </ul>
        </div>
        <div class="key_list_wrap sales_list_wrap">
            <el-table :data="List" border style="width: 100%" :header-cell-style="setHeaderStyle"
                @row-click="rowColorclick" highlight-current-row>
                <el-table-column prop="machineName" label="设备型号"></el-table-column>
                <el-table-column prop="macAddress" label="IMEI地址"></el-table-column>
                <el-table-column prop="employeeName" label="员工"></el-table-column>
                <el-table-column prop="statusName" label="状态"></el-table-column>
                <el-table-column prop="lastLoginTime" label="最后登录时间"></el-table-column>
                <el-table-column prop="inputTime" label="申请时间"></el-table-column>
                <el-table-column prop="remind" label="操作">
                    <template slot-scope="scope">
                        <span @click="macDelete(scope.row)" v-if="permisShow('移动端-解除绑定')"
                            :class="{rowColor:scope.row.id===isRowColor}"
                            style="color: #FF0000;cursor: pointer;padding-right:10px">解除绑定</span>
                        <span @click="macUpdateMacStatus(scope.row)"
                            v-if="scope.row.status=='NO'&&permisShow('移动端-机器认证')"
                            :class="{rowColor:scope.row.id===isRowColor}"
                            style="color: orange;cursor: pointer">认证</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="footer_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20"
                    layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
            </div>
        </div>

    </div>
</template>
<script type="text/javascript">
import AddKeyAlert from "@/components/common/addKeyAlert";
import {
    macQuery,
    macAdd,
    macDelete,
    macUpdate,
    macUpdateMacStatus,
    queryWebsiteCompany,
} from "@/api/systemSetup";
import { employeeQuery } from "@/api/manageCenter";
export default {
    // name: "机器认证",
    name: "phoneMacSet",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            permisList,
            isRowColor: "",
            total: 0,
            currentPage: 1,
            manageVisible: false,
            pageNumber: 1, //从第几条开始
            pageSize: 20, //显示条数
            // state: "不限", //状态
            List: [], //mac地址
            userList: [],
            departpopshow: false,
            defaultProps: {
                children: "child",
            },
            rules: {
                machineName: {
                    required: true,
                    message: "请输入机器名称",
                    trigger: "blur",
                },
                macAddress: {
                    required: true,
                    message: "请输入mac地址",
                    trigger: "blur",
                },
                employeeId: {
                    required: true,
                    message: "请选择员工",
                    trigger: "blur",
                },
            },
            statusList: [
                { name: "认证", value: "YES" },
                { name: "待认证", value: "NO" },
                { name: "无需认证", value: "NO_CHECK" },
            ],
            macData: {},
            whetherMacEmployee: "",
            //搜索
            search: {
                machineName: "", //机器名称
                macAddress: "", //mac地址
                status: "", //状态
                phoneEmployeeName: "", //员工姓名
                type: 1, //类型 0 客户端 1 手机端
            },
        };
    },
    components: {},
    mounted() {
        this.macQuery();
        this.Getmessage();
        this.queryWebsiteCompany();
        this.isRowColor = "";
    },
    activated() {
        this.macQuery();
        this.isRowColor = "";
    },
    methods: {
        permisShow(data) {
            // 权限配置
            let result = this.permisList.indexOf(data);
            console.log(23432343423, result);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },

        queryWebsiteCompany() {
            this.$post(queryWebsiteCompany).then((res) => {
                if (res.success) {
                    this.whetherMacEmployee = res.data.whetherMacEmployee;
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },

        Getmessage() {
            this.$post(employeeQuery).then((res) => {
                if (res.success === true) {
                    this.userList = res.data;
                }
            });
        },

        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.id;
        },

        macQuery() {
            this.isRowColor = "";
            let params = Object.assign({}, this.search);
            params["page.pageNumber"] = (this.pageNumber - 1) * this.pageSize;
            params["page.pageSize"] = this.pageSize;
            this.$post(macQuery, params).then((res) => {
                if (res.success) {
                    this.List = res.data;
                    this.total = res.total;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        macDelete(data) {
            this.$confirm("此操作将永久删除该绑定, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let params = Object.assign({}, data);
                    this.$post(macDelete, params).then((res) => {
                        if (res.success) {
                            this.$message({
                                type: "success",
                                message: res.msg,
                            });
                            this.macQuery();
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg,
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                    this.editSta = false;
                });
        },

        macUpdateMacStatus(data) {
            let params = {
                id: data.id,
                status: "YES",
            };
            this.$post(macUpdateMacStatus, params).then((res) => {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: res.msg,
                    });
                    this.macQuery();
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },

        clearPerson() {
            this.search.departmentName = "";
            this.search.departmentId = "";
            this.macQuery();
        },

        //分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            this.macQuery();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.macQuery();
        },

        //表单头部颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        },
    },
};
</script>
<style type="text/css" lang="less">
.phoneMacSet {
    background: #ffffff;
    .must {
        color: red;
        vertical-align: middle;
        margin-right: 2px;
    }
    .add-btn {
        height: 30px;
        min-width: 56px;
        padding: 5px 20px;
        background: #f5f5f5;
        margin-right: 34px;
        font-size: 14px;
        color: #ffffff;
        background: #5e75e6;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .tab {
        display: flex;
        align-items: center;
        &-item {
            width: 100px;
            height: 36px;
            font-size: 14px;
            line-height: 36px;
            background: #f1f1f1;
            text-align: center;
            cursor: pointer;
        }
        &-active {
            background: #ff9065;
            color: #ffffff;
        }
    }
    //弹出框样式
    .el-dialog {
        .el-dialog__title {
            color: #5e75e6;
        }
        .el-dialog__body {
            padding-top: 5px;
        }
        .el-form {
            padding: 0 30px;
            .el-form-item {
                margin-bottom: 10px !important;
                display: flex;
                align-items: center;
            }
        }
        .el-form-item__content {
            // margin-top: 0 !important;
            padding: 10px !important;
            margin: 0 !important;
        }
        .el-input {
            width: 290px;
            .el-input__inner {
                height: 30px !important;
            }
        }
        .el-select {
            width: 290px;
            .el-input__inner {
                height: 30px;
            }
        }
        .el-textarea {
            width: 290px;
            .el-input__inner {
                height: 30px;
            }
        }
    }
    .new-foot {
        width: 100%;
        height: 80px;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .delete,
    .save {
        width: 80px;
        height: 40px;
        border-radius: 4px;
        outline: none;
        border: none;
        color: #ffffff;
    }
    .delete {
        background: #999999;
        margin-right: 20px;
    }
    .save {
        background: #5e75e6;
        margin-right: 40px;
    }
    .departpop {
        width: 170px;
        position: absolute;

        left: 60px;
        top: 41px;
        z-index: 10;
        border: 1px solid #eee;
        .tree-item {
            display: flex;
            align-items: center;
            img {
                padding-right: 10px;
            }
        }
    }
    .key_list {
        display: flex;
        flex-wrap: wrap;
        .conditions_list_item {
            padding: 5px 10px 0 0;
            display: flex;
            align-items: center;
            margin-right: 10px;
            position: relative;
            // overflow: hidden;
            cursor: pointer;
            > span {
                font-size: 12px;
                color: #666666;
                padding: 4px 5px 4px 0;
            }
            .el-date-editor {
                margin-left: 10px;
                width: 310px;
                height: 30px;
                line-height: 30px;
                border: 1px solid #dbdbdb;
                .el-range-input {
                    // width: 310px;
                    line-height: 30px;
                    height: 28px;
                    border: none;
                    color: black;
                    padding-left: 30px;
                }
                .el-range-separator {
                    line-height: 26px;
                }
            }
            .el-select {
                margin-left: 10px;
                .el-input {
                    width: 80px;

                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 80px;
                        height: 30px;
                        color: black;
                        padding: 0 5px;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
            .shop {
                .el-input {
                    width: 100px;
                    .el-input__inner {
                        border: 1px solid #dbdbdb;
                        width: 100px;
                        height: 30px;
                        border: none;
                        color: black;
                        padding: 0;
                    }
                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }
        }
    }

    .key_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 30px;
        background: #fff;
        .el-input {
            width: 145px;
            height: 30px;

            .el-input-group__append,
            .el-input-group__prepend {
                padding: 0 10px;
                border: none;
            }

            .el-input__inner {
                height: 30px;
                padding-right: 10px;
            }

            .icon-icon_sousuo {
                color: white;
            }
        }

        .add_btn {
            width: 100px;
            height: 30px;
            background: #5e75e6;
            color: white;
            outline: none;
            border: none;
        }
    }

    .key_list_wrap {
        height: 90%;

        .el-dialog {
            width: 600px;

            .el-dialog__title {
                color: #5e75e6;
                font-size: 20px;
            }

            .el-dialog__close {
                font-size: 26px;
            }

            .el-dialog__body {
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 0;
            }
        }

        .footer_page {
            position: relative !important;
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }
        }
    }
}
</style>
